<fieldset [formGroup]="group" class="in-one-column">
  <app-cognac-properties-subform
    *ngIf="getCtrl('cognacProperties')"
    groupName="cognacProperties"
  >
  </app-cognac-properties-subform>

  <app-whisky-properties-subform
    *ngIf="getCtrl('whiskyProperties')"
    groupName="whiskyProperties"
  >
  </app-whisky-properties-subform>

  <app-rum-properties-subform
    *ngIf="getCtrl('rumProperties')"
    groupName="rumProperties"
  >
  </app-rum-properties-subform>

  <app-gin-properties-subform
    *ngIf="getCtrl('ginProperties')"
    groupName="ginProperties"
  >
  </app-gin-properties-subform>

  <app-vodka-properties-subform
    *ngIf="getCtrl('vodkaProperties')"
    groupName="vodkaProperties"
  >
  </app-vodka-properties-subform>

  <app-liqueur-properties-subform
    *ngIf="getCtrl('liqueurProperties')"
    groupName="liqueurProperties"
  >
  </app-liqueur-properties-subform>

  <app-bitter-properties-subform
    *ngIf="getCtrl('bitterProperties')"
    groupName="bitterProperties"
  >
  </app-bitter-properties-subform>

  <app-fruit-spirit-properties-subform
    *ngIf="getCtrl('fruitSpiritProperties')"
    groupName="fruitSpiritProperties"
  >
  </app-fruit-spirit-properties-subform>

  <app-tequila-properties-subform
    *ngIf="getCtrl('tequilaProperties')"
    groupName="tequilaProperties"
  >
  </app-tequila-properties-subform>

  <app-other-spirit-properties-subform
    *ngIf="getCtrl('otherSpiritProperties')"
    groupName="otherSpiritProperties"
  >
  </app-other-spirit-properties-subform>
</fieldset>
